import { apiRoutes } from "routes";
import FetchHelpers from "utils/FetchHelpers";

export default {
  get() {
    const url = apiRoutes.locationInfoPath(1);
    return FetchHelpers.get(url);
  },
};
